import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { HttpClientModule, HttpClient, HttpParams } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppMaterialModule, WtwUiComponentsModule, ConfigService } from 'wtw-ui-components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { APP_CONFIG, AppConfig } from './core/app.config';
import { SessionStorageService } from 'angular-web-storage';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { endPoints } from './core/app.config';
import { Location } from '@angular/common';
import { ConstantService } from './services/constants/constant.service';
import { CurrencyFormatPipe } from '../../../wtw-ui-components/src/lib/shared/pipes/currency-format.pipe';

export function initializeApp(configService: ConfigService, config) {
  const promise = configService.loadServiceConfigData(config);
  return () => promise;
}

export function httpLoaderFactory(
  http: HttpClient,
  location: Location,
  sessionStorage: SessionStorageService,
  constantService: ConstantService) {
  const sponsorId = sessionStorage.get('SponsorId');
  if (sponsorId) {
    return new TranslateHttpLoader(http, `${endPoints.apiUrl}Localization/GetTranslations/${sponsorId}/Shared/`);
  }
  const sponsorName = sessionStorage.get('SponsorName') || getUrlParameterByName(ConstantService.SponsorNameQueryParamName) || 'unknown';
  return new TranslateHttpLoader(http,
    `${endPoints.apiUrl}Localization/GetTranslationsForNamedSponsor/${sponsorName}/Shared/`);
}

function getUrlParameterByName(paramName: string) {
  const stashedResult = JSON.parse(sessionStorage.getItem('QueryParams'));
  if (stashedResult) {
    const queryParams = JSON.parse(stashedResult._value);
    return queryParams[paramName];
  }
  const url = window.location.href;
  let paramValue;
  if (url.includes('?')) {
    const httpParams = new HttpParams({ fromString: url.split('?')[1] });
    paramValue = httpParams.get(paramName);
  }
  return paramValue;
}


@NgModule({
  declarations: [
    AppComponent,
    CurrencyFormatPipe
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    WtwUiComponentsModule,
    FormsModule,
    AppMaterialModule,
    ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient, Location, SessionStorageService, ConstantService]
      }
    })

  ],
  providers: [
    ConstantService,
    { provide: APP_CONFIG, useValue: AppConfig },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp, deps: [ConfigService, APP_CONFIG], multi: true
    },
    CurrencyFormatPipe
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class AppModule { }
